import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 align-items-center" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = {
  key: 0,
  class: "fw-bolder m-0"
}
const _hoisted_5 = {
  key: 1,
  class: "fw-bolder m-0"
}
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_8 = { class: "card-title m-0 mb-5" }
const _hoisted_9 = { class: "fw-bolder m-0" }
const _hoisted_10 = { class: "my-8 mb-20" }
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle-fill text-muted ms-1" }, null, -1)
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = {
  key: 1,
  class: "text-muted col-2 align-self-center"
}
const _hoisted_41 = { class: "row mb-6" }
const _hoisted_42 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle-fill text-muted ms-1" }, null, -1)
const _hoisted_44 = { class: "col-lg-8 fv-row" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15" }, null, -1)
const _hoisted_50 = { class: "card-title m-0 mb-3 mt-20" }
const _hoisted_51 = { class: "fw-bolder m-0" }
const _hoisted_52 = { class: "my-8 mb-10" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-12 fv-row" }
const _hoisted_55 = { class: "fv-plugins-message-container" }
const _hoisted_56 = { class: "fv-help-block" }
const _hoisted_57 = { class: "justify-content-center mt-15 mb-5 text-center" }
const _hoisted_58 = { class: "justify-content-center text-center" }
const _hoisted_59 = {
  key: 1,
  class: "card-body border-top p-9"
}
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle-fill text-muted ms-1" }, null, -1)
const _hoisted_63 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_64 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_65 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_68 = { class: "fv-plugins-message-container" }
const _hoisted_69 = { class: "fv-help-block" }
const _hoisted_70 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_71 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_72 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_73 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_74 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_77 = { class: "fv-plugins-message-container" }
const _hoisted_78 = { class: "fv-help-block" }
const _hoisted_79 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_80 = { class: "col-lg-3 col-form-label fw-bold fs-6" }
const _hoisted_81 = {
  key: 0,
  class: "col-lg-8 fv-row"
}
const _hoisted_82 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_83 = {
  key: 1,
  class: "col-lg-8 fv-row"
}
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_86 = { class: "fv-plugins-message-container" }
const _hoisted_87 = { class: "fv-help-block" }

import { textSearch } from "@/assets/ts/_utils";
import { showBackendError } from "@/assets/ts/_utils/ShowBackendError";
import { diffObjects } from "@/core/helpers/diffObjects";
import { SortProps, sortFn } from "@/core/helpers/sort";
import { ProyectosN2Listado } from "@/store/models";
import {
  AuthModule,
  FormulariosModule,
  OrganismosModule,
  ProyectosN2ListadoModule,
} from "@/store/modules";
import Swal from "sweetalert2";
import { ErrorMessage, useField, useForm } from "vee-validate";
import { computed, onBeforeMount, onMounted, reactive, ref, watch } from "vue";
import { useArrayPagination } from "vue-composable";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { getModule } from "vuex-module-decorators";
import * as Yup from "yup";

interface FormState {
  codigo?: string | null;
  proyectoPadreId: string;
  denominacion: string;
  descripcion?: string | null;
  formularioPublicoId?: string | null;
  cuerpoEmail?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const store = useStore();
const module = getModule(ProyectosN2ListadoModule, store);
const authModule = getModule(AuthModule, store);
const organismoModule = getModule(OrganismosModule, store);
const formulariosModule = getModule(FormulariosModule, store);

const comarcaId = authModule.user.comarcaId;
const route = useRoute();
const token = route.params.id as string;

const solicitud = computed(() => formulariosModule.solicitud);

const formularioBaseUrl = process.env.VUE_APP_FORMULARIOS_URL;

const fetchOrganizacionesList = async function () {
  await organismoModule.fetchTipoOrganizaciones();
};
const listadoTiposOrganizaciones = computed(
  () => organismoModule.tiposOrganizacionListado
);

const fetchFormulariosList = async function () {
  await formulariosModule.fetchAll();
};
const listadoFormularios = computed(() => formulariosModule.formulariosListado);

const editingInfo = ref<boolean>(false);
const creandoProyectoN2 = ref<boolean>(false) ? !token : true;
//const cargaDetalle = ref<boolean>(false); animacion de carga

const schema = Yup.object({
  codigo: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.codigo.label")),
  proyectoPadreId: Yup.string()
    .required()
    .label(t("formularios.proyectoN2Detalle.proyectoPadreId.label")),
  denominacion: Yup.string()
    .required()
    .label(t("formularios.proyectoN2Detalle.denominacion.label")),
  descripcion: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.descripcion.label")),
  formularioPublicoId: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.formularioPublicoId.label")),
  cuerpoEmail: Yup.string()
    .nullable()
    .label(t("formularios.proyectoN2Detalle.cuerpoEmail.label")),
});

const { resetForm, handleSubmit, meta } = useForm<Partial<FormState>>({
  validationSchema: schema,
});

const guardaDetalle = ref<boolean>(false);
const guardarProyectoN2 = handleSubmit(async (values) => {
  guardaDetalle.value = true;

  const update: Partial<ProyectosN2Listado> = diffObjects(
    meta.value.initialValues,
    values
  );

  if (Object.keys(update).length) {
    await module
      .updateById({
        id: token,
        comarcaId: comarcaId,
        proyectoN2: {
          ...update,
        },
      })
      .then(() => {
        return Swal.fire({
          text: t("formularios.proyectosN2.guardar.mensaje.exito"),
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          editingInfo.value = false;
          module.fetchById({ comarcaId: comarcaId, id: token as string });
        });
      })
      .catch((err) => {
        if (typeof err === "object" && err?.error?.statusCode < 500) {
          showBackendError(t, err.error);
        } else {
          Swal.fire({
            text: t("formularios.proyectosN2.cargar.error"),
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: t("dialogs.okButton"),
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
        }
      })
      .finally(() => {
        guardaDetalle.value = false;
      });
  } else {
    Swal.fire({
      text: t("formularios.proyectosN2.guardar.mensaje.exito"),
      icon: "success",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    }).then(() => {
      editingInfo.value = false;
      module.fetchById({ comarcaId: comarcaId, id: token as string });
    });
    guardaDetalle.value = false;
  }
});

//Modificar esta funcion para mandar las solicitudes
const solicitarDatos = handleSubmit(async (values) => {
  // TODO mostrar resumen de Organismos seleccionados
  guardaDetalle.value = true;
  try {
    const solicitudCrear = {
      proyectoPadreId: values.proyectoPadreId,
      denominacion: values.denominacion,
      descripcion: values.descripcion ?? null,
      formularioPublicoId: values.formularioPublicoId ?? null,
      cuerpoEmail: values.cuerpoEmail ?? undefined,
      organismosIds: state.multipleSelection.map((ele) => ele.id),
    };

    await formulariosModule.crearSolicitud({
      solicitudCrear: solicitudCrear,
    });

    if (formulariosModule.errors) {
      const err = formulariosModule.errors;
      if (
        err.error?.statusCode === 422 &&
        err.error?.message === "CODIGO_PROYECTO_INCORRECTO"
      ) {
        await Swal.fire({
          text: t("formularios.solicitud.crear.mensaje.codigoIncorrecto"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      } else {
        await Swal.fire({
          text: t("formularios.solicitud.crear.mensaje.error"),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("dialogs.okButton"),
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });
      }
    } else {
      await Swal.fire({
        text: t("formularios.solicitud.crear.mensaje.exito"),
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: t("dialogs.okButton"),
        customClass: { confirmButton: "btn btn-primary" },
      });
      router.replace("/listados/recoleccion-de-datos");
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    await Swal.fire({
      text: t("formularios.solicitud.crear.mensaje.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    formulariosModule.clearErrors();
    guardaDetalle.value = false;
  }
});

onBeforeMount(() => {
  load();
});
onMounted(async () => {
  fetchOrganizacionesList();
  fetchFormulariosList();

  if (!token) {
    resetForm({
      values: {
        codigo: "",
        proyectoPadreId: "",
        denominacion: "",
      },
    });
  }
});

watch(solicitud, () => {
  if (!solicitud.value) return;

  resetForm({
    values: {
      proyectoPadreId: solicitud.value.proyectoPadre.codigo,
      denominacion: solicitud.value.denominacion,
      descripcion: solicitud.value.descripcion,
    },
  });
});

const { value: proyectoPadreId } = useField("proyectoPadreId");
const { value: denominacion } = useField("denominacion");
const { value: descripcion } = useField("descripcion");
const { value: formularioPublicoId } = useField("formularioPublicoId");
const { value: cuerpoEmail } = useField("cuerpoEmail");

const organismos = computed(() => {
  return organismoModule.organismosListado?.map((ele) => {
    return {
      ...ele,
      tipoOrganizacionNombre: ele.tipoOrganizacion?.nombre,
    };
  });
});

const state = reactive({
  multipleSelection: [] as { id: string; nombre: string }[],
});

// Función para manejar el cambio de selección
const handleSelectionChange = (selection) => {
  state.multipleSelection = selection;
};

// Busqueda y ordenación.
const search = ref("");
const filter = ref("");
const sortProps = ref<SortProps>({
  prop: "createdOn",
  order: "descending",
  method: null,
});
const sortChange = ({ column, prop, order }) => {
  sortProps.value = { prop, order, method: column.sortMethod };
};
const filteredCollection = computed(function () {
  return organismos.value
    .slice()
    .sort(sortFn(sortProps))
    .filter((data) => {
      const filterCondition =
        !filter.value || textSearch(data.tipoOrganizacionId, filter.value);

      const searchCondition =
        !search.value ||
        textSearch(data.tipoOrganizacionId, search.value) ||
        textSearch(data.nombre, search.value) ||
        textSearch(data.telefono, search.value) ||
        textSearch(data.direccion, search.value) ||
        textSearch(data.email, search.value) ||
        textSearch(data.emailProfesionales, search.value);

      return filterCondition && searchCondition;
    });
});

// Paginación.
const { result, currentPage } = useArrayPagination(filteredCollection, {
  pageSize: 500,
});
const handleCurrentPageChange = (page: number) => (currentPage.value = page);

const cargaListado = ref(false);
const load = async () => {
  cargaListado.value = true;
  try {
    await organismoModule.fetchAll();
    search.value = "";
    filter.value = "";
    currentPage.value = 1;
  } catch (error) {
    Swal.fire({
      text: t("formularios.organismo.cargarListado.error"),
      icon: "error",
      buttonsStyling: false,
      confirmButtonText: t("dialogs.okButton"),
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  } finally {
    cargaListado.value = false;
  }
};

const verFormulario = (tipoFormulario) => {
  if (tipoFormulario) {
    window.open(
      `${formularioBaseUrl}/#/solicitud-informacion?form=${tipoFormulario}&me=test&sol=test`
    );
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (!_unref(creandoProyectoN2))
            ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.titulo")), 1))
            : (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.tituloCreacion")), 1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_unref(creandoProyectoN2))
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.tipo.titulo")), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.tipo.texto")), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.proyectoPadreId.label")) + " ", 1),
                _createVNode(_component_el_tooltip, {
                  class: "me-1",
                  content: 
              _ctx.$t('formularios.proyectoN2Detalle.proyectoPadreId.tooltip')
            
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_el_input, {
                      type: "text",
                      name: "proyectoPadreId",
                      placeholder: "",
                      modelValue: _unref(proyectoPadreId),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(proyectoPadreId) ? (proyectoPadreId).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_unref(ErrorMessage), { name: "proyectoPadreId" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.denominacion.label")), 1),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_el_input, {
                      type: "text",
                      name: "denominacion",
                      placeholder: " ",
                      modelValue: _unref(denominacion),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(denominacion) ? (denominacion).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_unref(ErrorMessage), { name: "denominacion" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.descripcion.label")), 1),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_el_input, {
                      type: "text",
                      name: "descripcion",
                      placeholder: " ",
                      modelValue: _unref(descripcion),
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(descripcion) ? (descripcion).value = $event : null))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_unref(ErrorMessage), { name: "descripcion" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.tipo.tipo")), 1),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_el_select, {
                      name: "formularioPublicoId",
                      modelValue: _unref(formularioPublicoId),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(formularioPublicoId) ? (formularioPublicoId).value = $event : null)),
                      class: "w-100"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listadoFormularios), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.nombre,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_unref(ErrorMessage), { name: "formularioPublicoId" })
                      ])
                    ])
                  ]),
                  (_unref(formularioPublicoId))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "text-primary col-2 align-self-center",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (verFormulario(_unref(formularioPublicoId)))),
                        style: {"cursor":"pointer"}
                      }, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.tipo.ver")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.tipo.ver")), 1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", _hoisted_42, [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.cuerpoEmail.label")) + " ", 1),
                _createVNode(_component_el_tooltip, {
                  class: "me-1",
                  content: _ctx.$t('formularios.proyectoN2Detalle.cuerpoEmail.tooltip')
                }, {
                  default: _withCtx(() => [
                    _hoisted_43
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_el_input, {
                      rows: 3,
                      autosize: { minRows: 3 },
                      type: "textarea",
                      placeholder: 
                  _ctx.$t('formularios.proyectoN2Detalle.cuerpoEmail.placeholder')
                ,
                      modelValue: _unref(cuerpoEmail),
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(cuerpoEmail) ? (cuerpoEmail).value = $event : null)),
                      name: "cuerpoEmail"
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_unref(ErrorMessage), { name: "cuerpoEmail" })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("h3", _hoisted_51, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.organismos.titulo")), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("formulario.proyecto.resumen.organismos.texto")), 1)
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_component_el_select, {
                  class: "me-5",
                  name: "tipoOrganizacion",
                  modelValue: filter.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filter).value = $event)),
                  clearable: "",
                  placeholder: "Selecciona tipo de organización"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listadoTiposOrganizaciones), (tipoOrg, i) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: i,
                        label: tipoOrg.nombre,
                        value: tipoOrg.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: search.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((search).value = $event)),
                  style: {"width":"300px"},
                  placeholder: _ctx.$t('tabla.buscador.placeholder')
                }, null, 8, ["modelValue", "placeholder"]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createVNode(_unref(ErrorMessage), { name: "tipoOrganizacion" })
                  ])
                ])
              ])
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _unref(result),
              style: {"width":"100%"},
              stripe: "",
              ref: "multipleTable",
              class: "mt-10 border-top",
              "default-sort": { prop: 'nombre', order: 'ascending' },
              onSortChange: sortChange,
              onSelectionChange: handleSelectionChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "selection",
                  "min-width": "40"
                }),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('tabla.organismo.cabecera.nombre'),
                  prop: "nombre",
                  sortable: "",
                  "min-width": "120"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('tabla.organismo.cabecera.tipoOrganismo'),
                  prop: "tipoOrganizacionNombre",
                  sortable: "",
                  "min-width": "100"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('tabla.organismo.cabecera.telefono'),
                  prop: "telefono",
                  sortable: "",
                  "min-width": "100"
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('tabla.organismo.cabecera.correo'),
                  prop: "emailProfesionales",
                  sortable: "",
                  "min-width": "150"
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])), [
              [_directive_loading, cargaListado.value]
            ]),
            _createVNode(_component_el_pagination, {
              class: "my-5 float-end",
              background: "",
              "page-size": 500,
              layout: "prev, pager, next",
              total: _unref(organismos).length,
              "hide-on-single-page": true,
              "current-page": _unref(currentPage),
              onCurrentChange: handleCurrentPageChange
            }, null, 8, ["total", "current-page"]),
            _createElementVNode("div", _hoisted_57, _toDisplayString(_unref(state).multipleSelection.length) + " " + _toDisplayString(_ctx.$t("formulario.proyecto.resumen.organismos.organismosSeleccionados")), 1),
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _unref(solicitarDatos),
                disabled: _unref(state).multipleSelection.length === 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("formularios.solicitarDatos.button")), 1)
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ]))
        : _createCommentVNode("", true),
      (!_unref(creandoProyectoN2))
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("label", _hoisted_61, [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.proyectoPadreId.label")) + " ", 1),
                _createVNode(_component_el_tooltip, {
                  class: "me-1",
                  content: 
              _ctx.$t('formularios.proyectoN2Detalle.proyectoPadreId.tooltip')
            
                }, {
                  default: _withCtx(() => [
                    _hoisted_62
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              (!editingInfo.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("label", _hoisted_64, _toDisplayString(_unref(solicitud)?.proyectoPadre.codigo ?? "-"), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "proyectoPadreId",
                          placeholder: "",
                          modelValue: _unref(proyectoPadreId),
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(proyectoPadreId) ? (proyectoPadreId).value = $event : null))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createVNode(_unref(ErrorMessage), { name: "proyectoPadreId" })
                          ])
                        ])
                      ])
                    ])
                  ]))
            ]),
            (!_unref(creandoProyectoN2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.denominacion.label")), 1),
                  (!editingInfo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                        _createElementVNode("label", _hoisted_73, _toDisplayString(_unref(solicitud)?.denominacion ?? "-"), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "denominacion",
                              placeholder: " ",
                              modelValue: _unref(denominacion),
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(denominacion) ? (denominacion).value = $event : null))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_77, [
                              _createElementVNode("div", _hoisted_78, [
                                _createVNode(_unref(ErrorMessage), { name: "denominacion" })
                              ])
                            ])
                          ])
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true),
            (!_unref(creandoProyectoN2))
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("formularios.proyectoN2Detalle.descripcion.label")), 1),
                  (!editingInfo.value && !_unref(creandoProyectoN2))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                        _createElementVNode("label", _hoisted_82, _toDisplayString(_unref(solicitud)?.descripcion ?? "-"), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_el_input, {
                              type: "text",
                              name: "descripcion",
                              placeholder: " ",
                              modelValue: _unref(descripcion),
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(descripcion) ? (descripcion).value = $event : null))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_86, [
                              _createElementVNode("div", _hoisted_87, [
                                _createVNode(_unref(ErrorMessage), { name: "descripcion" })
                              ])
                            ])
                          ])
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})